import { goalbookUrls } from '@/links'
import { getCookie } from './request_handler'

export async function getDisabilitiesAndImpactAreas(licenseSubType, contentProfile) {
  let options = {
    license_sub_type: licenseSubType,
    content_profile: contentProfile,
  }
  const params = new URLSearchParams(options)
  const response = await fetch(
    `${
      goalbookUrls.presentlevels
    }/presentlevels/api/v1/impact-of-disability/disabilities?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    }
  )
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON,
  }
}

export async function getIODStatementsByImpactArea(disabilityUuid, contentProfile) {
  let options = {
    disability: disabilityUuid,
    content_profile: contentProfile,
  }
  const params = new URLSearchParams(options)
  const response = await fetch(
    `${
      goalbookUrls.presentlevels
    }/presentlevels/api/v1/impact-of-disability/statements?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    }
  )
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON,
  }
}

export async function generateIODStatements({ disability, subjects, impactAreas, contentProfile, betaMode }) {
  if (!disability || typeof disability !== 'string') {
    throw new Error('disability is required and must be a string');
  }

  if (!subjects || !Array.isArray(subjects) || subjects.length === 0) {
    throw new Error('subjects is required and must be a non-empty array');
  }

  const payload = {
    disability,
    subjects,
    impact_areas: impactAreas,
    content_profile: contentProfile,
    beta_only: betaMode,
  };

  try {
    const gbcs = getCookie('gbcs')
    const response = await fetch(`${goalbookUrls.presentlevels}/api/v2/iod/statements/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': gbcs,
      },
      credentials: 'include',
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message ||
        `HTTP error! status: ${response.status}`
      );
    }

    const data = await response.json();
    return data;

  } catch (error) {
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      throw new Error('Network error: Failed to connect to the API');
    }
    throw error;
  }
}
